import {ResultEmpty} from '@components/competitions/levels/imamreza/ResultEmpty';
import {
	ArtistShared,
	CalmAtmosphereShared,
	InteractionOrientedShared,
	SearcherShared,
	ServantShared
} from '@components/competitions/levels/imamreza/results-detailes';
import {appConfig} from '@config';
import {Gender, Lang, PersonalityType} from '@context/CompetitionImamrezaContext';
import scopedI18n from '@locale/scoped-i18n';
import {saveLang} from '@utils/langStorage';
import axios from 'axios';
import React from 'react';
import {LoaderFunctionArgs, useLoaderData, useParams} from 'react-router-dom';

interface loader {
	request: Request;
	params: {};
	referral_code: string;
}

const componentMap: Record<PersonalityType, React.ComponentType<{
	gender: Gender,
	showDetails?: boolean,
	lang: Lang,
	referralCode: string
}>> = {
	artist: ArtistShared,
	peaceful: CalmAtmosphereShared,
	interaction: InteractionOrientedShared,
	servant: ServantShared,
	searcher: SearcherShared
};

type LoaderData = {
	referralCode: string,
	gender: Gender,
	type: PersonalityType,
	lang: Lang
}

export default function SharedResult() {
	const {ref} = useParams();
	const {referralCode, gender, type, lang} = useLoaderData() as LoaderData;
	// Ensure both gender and type are valid
	if (!gender || !type || !(type in componentMap)) {
		return <ResultEmpty lang={lang}/>; // or show an error/fallback
	}
	saveLang(lang);
	scopedI18n.changeLanguage(lang);
	const SelectedComponent = componentMap[type as PersonalityType];
	
	return <SelectedComponent gender={gender as Gender} lang={lang} referralCode={referralCode} showDetails={false}/>;
}

export async function competitionSharedImamrezaLoader({params}: LoaderFunctionArgs) {
	const {ref} = params;
	
	if (!ref) {
		throw new Error('Missing referral code in URL');
	}
	
	const res = await axios({
		url: `${appConfig.competition2.url}imamreza-result`,
		method: 'POST',
		data: {
			referral_code: ref
		}
	});
	
	if (res.data.success) {
		return res.data.result;
	} else {
		return res.data;
		// throw new Error(res.data.error || 'Failed to fetch result');
	}
}
